// import { Link } from 'react-router-dom';
// import loginImg from '../images/login-img.png';
// import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    //Form Variables
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [verifyPassword, setVerifyPassword] = useState("");
    const [isPending, setIsPending] = useState(false)
    const navigate = useNavigate();
    const base_url = process.env.REACT_APP_BASE_URL;
    //toasts for failed password notification=====================
    const signupFail = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
    const signupSuccess = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsPending(true)
        if (password === verifyPassword) {
            // Make axios POST request to add data to the database
            axios.post(`${base_url}/auth/admin-sign-up`, {
                "email": email,
                "password": password,
                "verifypassword": verifyPassword
            })
                .then(function (response) {
                    console.log(response.data)
                    console.log(response);
                    signupSuccess(
                        "Admin account was successfully created. Routing to Login"
                    );
                    setTimeout(() => {
                        navigate("/login");
                    }, 3000);
                })
                .catch(function (error) {
                    if (error.response !== undefined) {
                        //Log error message 
                        console.log(error.response.data.msg)
                        signupFail(error.response.data.msg)
                        setIsPending(false)
                    }
                    else if (error.response === undefined) {
                        signupFail("Sorry a Network Error occurred while trying to log you in. Please try again");
                        setIsPending(false)
                    }
                });
        }//conditional if
        else {
            signupFail("Please enter matching passwords");
            setIsPending(false)
        }
    }
    return (
        <>
            {/* <div className="bg-pattern"> */}
                <br /><br />
                <ToastContainer />
                <div className="container my-5">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-4">
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-4">
                            <center>
                                <h4 className="bold text-custom">CORPER INVEST MOBILE DASHBOARD</h4>
                            </center>
                            <div className="login-container px-3 py-5 shadow container-radius bg-white">
                                <div className="text-center">
                                    <h4 className="section-title"><i className="bi-person-add"></i> Admin Account</h4>
                                    <small className="login-caption">
                                        Create new administrator account.
                                    </small>
                                </div>
                                <form onSubmit={handleSubmit} className="mt-3">
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-envelope"></i></span>
                                        <input type="email" className="form-control custom-input-group" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-person-lock"></i></span>
                                        <input type="password" className="form-control custom-input-group" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-person-lock"></i></span>
                                        <input type="password" className="form-control custom-input-group" value={verifyPassword} onChange={(e) => setVerifyPassword(e.target.value)} placeholder="Confirm Password" required />
                                    </div>
                                    {
                                        isPending ?
                                            (
                                                <button className="btn-custom w-100 mt-1 btn-disabled" disabled>
                                                    Creating Account
                                                    <div className="spinner-border spinner-border-sm text-light ms-2"></div>
                                                </button>
                                            ) : (
                                                <button className="btn-custom w-100 mt-1"><i className="bi bi-person-plus"></i> Create Account</button>
                                            )
                                    }
                                    <div className="text-center">
                                        <small>or</small><br />
                                        {/* <Link to="/login" className="pointer"> */}
                                            <button className="custom-link"><i className="bi-box-arrow-in-right"></i> Login as Admin</button>
                                        {/* </Link> */}
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-4"></div>
                    </div>
                </div>
                <br/><br/>
                <Footer />
            {/* </div> */}

        </>

    )
}

export default Login;